import { render, staticRenderFns } from "./WebRTCVideoV2.vue?vue&type=template&id=3d1b7dc4&scoped=true"
import script from "./WebRTCVideoV2.vue?vue&type=script&lang=js"
export * from "./WebRTCVideoV2.vue?vue&type=script&lang=js"
import style0 from "./WebRTCVideoV2.vue?vue&type=style&index=0&id=3d1b7dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b7dc4",
  null
  
)

export default component.exports